"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Diamond02 = function Diamond02(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5.0003 22h14m-16.5-14h19m-11.5-6-2 6 4 10.5 4-10.5-2-6m-1.408 16.3489 8.9396-9.8336c.166-.1827.2491-.274.2821-.378a.5.5 0 0 0 .0061-.2825c-.0285-.1053-.1076-.2001-.2656-.3898l-4.3143-5.177c-.0882-.1059-.1322-.1588-.1863-.1968a.5.5 0 0 0-.1579-.074C16.8322 2 16.7634 2 16.6256 2H7.375c-.1377 0-.2066 0-.2704.0172a.5.5 0 0 0-.1578.074c-.054.038-.0982.0908-.1863.1967L2.4462 7.465c-.158.1896-.237.2845-.2657.3898a.5.5 0 0 0 .0061.2825c.0331.104.1161.1953.2822.378l8.9396 9.8336c.2052.2257.3078.3386.4284.3803a.5.5 0 0 0 .3271 0c.1206-.0417.2232-.1546.4284-.3803"
    })
  }));
};
var _default = exports["default"] = Diamond02;